export const roundToTwoDecimals = (value: number) =>
  Number((Math.round(value * 100) / 100).toFixed(2));
